import type {
  CreatePriceOverride,
  GetOnePriceOverrideResponse,
  PriceOverrideDB,
} from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import type { UndefinedToNull } from "@/components/Account/types";
import { learningServiceRequest } from "@/services/utils";

export const getQueryKey = () => ["createPriceOverride"];

type CreatePriceOverrideArgs = {
  payload: UndefinedToNull<CreatePriceOverride>;
  name?: string;
};

export const useCreatePriceOverride = (
  useMutationOptions?: UseMutationOptions<PriceOverrideDB, Error, CreatePriceOverrideArgs>,
) => {
  return useMutation<PriceOverrideDB, Error, CreatePriceOverrideArgs>({
    mutationFn: async ({ payload }) => {
      const response: AxiosResponse<GetOnePriceOverrideResponse> = await learningServiceRequest({
        method: "post",
        url: "/price_overrides/",
        payload: payload,
      });
      return response.data.data;
    },
    ...useMutationOptions,
  });
};
